<template>
  <v-dialog max-width="500px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Trigger Wonder</span>
      </v-card-title>

      <v-row class="px-2 px-md-6">
              <v-col cols="12">
                <r-item-dropdown :model.sync="model.platform" label="Platform"/>
                <r-item-dropdown :model.sync="model.item" label="Item"/>
                <r-currency-kind-dropdown :model.sync="model.currency" label="Currency"/>
              </v-col>
      </v-row>


      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import VueTypes from "vue-types";

import {ViewRules} from "@/common/ViewRules";
import  {WorldRegionWonderModel}  from "@/modules/redactor/models/world-region/wonder/WorldRegionWonderModel";

import RCurrencyKindDropdown from "@/modules/redactor/views/currency-kind/r-currency-kind-dropdown.vue";
import RItemDropdown from "@/modules/redactor/views/item/r-item-dropdown.vue";

export default {
  name: "r-trigger-wonder",
  components: {RCurrencyKindDropdown, RItemDropdown},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: VueTypes.objectOf(WorldRegionWonderModel),
    rules: ViewRules.READONLY,
  }),
  computed: {
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new WorldRegionWonderModel();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    }
  }
}
</script>

<style lang="css" scoped>
.fill-width {
  width: 100%;
}
</style>